import React, { useState, useEffect } from "react";
import axiosClient from "../../utilities/axios_client";
import {
  Button,
  Text,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeadCell,
  TableCell,
  LoadingMessage,
  Card,
} from "../../groundworkui-ui";
import ProjectsFormModal from "./projects_form/projects_form_modal";

const ProjectsIndex = () => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [showProjectsFormModal, setShowProjectsFormModal] = useState(false);

  const loadProjects = () => {
    axiosClient.get("/projects").then((response) => {
      setProjects(response.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    loadProjects();
  }, []);

  if (loading) {
    return <LoadingMessage message="Loading projects..." />;
  }

  return (
    <>
      <div className="flex flex-col items-start gap-2">
        <Text type="h1">Projects</Text>

        {projects.length === 0 ? (
          <Card type="empty-state">You do not have any projects setup.</Card>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell className="text-left">Name</TableHeadCell>
                <TableHeadCell className="text-left">Updated</TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {projects.map((project) => {
                return (
                  <TableRow
                    onClick={() =>
                      (window.location.href = `/projects/${project.id}`)
                    }
                    key={project.id}
                    className="cursor-pointer"
                  >
                    <TableCell>
                      <Text className="font-normal">{project.name}</Text>
                    </TableCell>
                    <TableCell>{project.updated_at}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}

        <Button
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setShowProjectsFormModal(true);
          }}
        >
          Create New Project
        </Button>
      </div>
      {showProjectsFormModal && (
        <ProjectsFormModal onClose={() => setShowProjectsFormModal(false)} />
      )}
    </>
  );
};

export default ProjectsIndex;
